const BAR_CHART_CORNER_RADIUS = 4;

/** Rounds the top corners: standalone bars and the topmost segment of a stack. */
export const BAR_CHART_RADIUS: [number, number, number, number] = [
    BAR_CHART_CORNER_RADIUS,
    BAR_CHART_CORNER_RADIUS,
    0,
    0,
];

/** Rounds the bottom corners: the baseline segment of a stack. */
export const BAR_CHART_BOTTOM_RADIUS: [number, number, number, number] = [
    0,
    0,
    BAR_CHART_CORNER_RADIUS,
    BAR_CHART_CORNER_RADIUS,
];
